import { container } from "tsyringe";
export class UseCaseGetExchangeRates {
    async getExchangeRates(symbol) {
        const getExchangeRates = container.resolve("iGetExchangeRates");
        const exchangeRates = await getExchangeRates.getExchangeRates(symbol);
        return exchangeRates;
    }
}
